import { useState, useEffect } from "react";

export default function Carousel() {
  const images = [
    "/images/carousel1.png",
    "/images/carousel2.png",
    "/images/carousel3.png",
    "/images/carousel4.png",
    "/images/carousel5.png",
  ];

  const [current, setCurrent] = useState(0);

  // Auto slide every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div className="relative w-full h-[300px] sm:h-[400px] md:h-[500px] overflow-hidden">
      {/* Images Wrapper */}
      <div
        className="flex w-full h-full transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            className="w-full h-full object-fill flex-shrink-0"
            alt=""
          />
        ))}
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 w-full flex justify-center gap-2">
        {images.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-3 h-3 rounded-full transition-all
              ${current === idx ? "bg-white scale-125" : "bg-white/40"}
            `}
          />
        ))}
      </div>
    </div>
  );
}
